import React from 'react';

type IconProps = {
    width?: number;
    height?: number;
    color?: string;
};

const IconAddText: React.FC<IconProps> = ({ width = 28, height = 28, color = 'black' }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 28 28"
            fill="none"
        >
            <path
                d="M20.4596 4.52799V9.11133C20.4596 9.34049 20.2721 9.52799 20.043 9.52799H17.1263C16.8971 9.52799 16.7096 9.34049 16.7096 9.11133V7.44466H14.6263V19.1113H16.293C16.5221 19.1113 16.7096 19.2988 16.7096 19.528V21.6113C16.7096 21.8405 16.5221 22.028 16.293 22.028H9.20964C8.98047 22.028 8.79297 21.8405 8.79297 21.6113V19.528C8.79297 19.2988 8.98047 19.1113 9.20964 19.1113H10.8763V7.44466H8.79297V9.11133C8.79297 9.34049 8.60547 9.52799 8.3763 9.52799H5.45964C5.23047 9.52799 5.04297 9.34049 5.04297 9.11133V4.52799C5.04297 4.29883 5.23047 4.11133 5.45964 4.11133H20.043C20.2721 4.11133 20.4596 4.29883 20.4596 4.52799Z"
                fill={color}
            />
            <path
                d="M22.9603 2.44434H2.54362C2.31445 2.44434 2.12695 2.63184 2.12695 2.861V23.2777C2.12695 23.5068 2.31445 23.6943 2.54362 23.6943H17.6853C17.6436 23.6193 17.602 23.5402 17.5603 23.461C17.4645 23.2693 17.3853 23.0693 17.3186 22.861H2.96029V3.27767H22.5436V17.636C22.752 17.7027 22.952 17.786 23.1478 17.8818C23.227 17.9193 23.302 17.961 23.377 18.0068V2.861C23.377 2.63184 23.1895 2.44434 22.9603 2.44434Z"
                fill={color}
            />
            <path
                d="M23.1478 17.8818C22.577 17.5943 21.9353 17.4443 21.2936 17.4443C18.9978 17.4443 17.127 19.3152 17.127 21.611C17.127 22.2527 17.277 22.8943 17.5603 23.461C18.2728 24.8902 19.702 25.7777 21.2936 25.7777C23.5895 25.7777 25.4603 23.9068 25.4603 21.611C25.4603 20.0193 24.5728 18.5902 23.1478 17.8818ZM23.377 22.0277H21.7103V23.6943C21.7103 23.9243 21.5236 24.111 21.2936 24.111C21.0636 24.111 20.877 23.9243 20.877 23.6943V22.0277H19.2103C18.9803 22.0277 18.7936 21.841 18.7936 21.611C18.7936 21.381 18.9803 21.1943 19.2103 21.1943H20.877V19.5277C20.877 19.2977 21.0636 19.111 21.2936 19.111C21.5236 19.111 21.7103 19.2977 21.7103 19.5277V21.1943H23.377C23.607 21.1943 23.7936 21.381 23.7936 21.611C23.7936 21.841 23.607 22.0277 23.377 22.0277Z"
                fill={color}
            />
        </svg>
    );
};

export default IconAddText;
